export const queryKeys = {
  session: () => ["session"] as const,
  hasOrganizations: () => ["hasOrganizations"] as const,
  authUiOrganizations: () => ["organizations"] as const,
  authUiActiveOrganizations: () => ["active-organization"] as const,
};
